<script setup>
import RoleCards from '~/views/apps/roles/RoleCards.vue'
import UserList from '~/views/apps/roles/UserList.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
definePage({
  meta: {
    action: 'view',
    subject: 'user',
  },
})

</script>

<template>
  <VRow>
    <VCol v-if="$can('view', 'role')" cols="12">
      <h4 class="text-h4 mb-6">
        {{ $t('admin_notifications.roles_list') }}
      </h4>
      <p class="mb-0">
        {{ $t('admin_notifications.roles_description') }}
      </p>
    </VCol>

    <!-- 👉 Roles Cards -->
    <VCol cols="12">
      <RoleCards v-if="$can('view', 'role')" />
    </VCol>

    <VCol cols="12">
      <!-- 👉 User List  -->
      <UserList v-if="$can('view', 'user')" />
    </VCol>
  </VRow>
</template>
